import script from "./TarjetaLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./TarjetaLanding.vue?vue&type=script&setup=true&lang=js"

import "./TarjetaLanding.vue?vue&type=style&index=0&id=79d4019e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d4019e"]])

export default __exports__